import '@babel/polyfill'
import 'mutationobserver-shim'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import store from './store'
import initLoginType from './config/initLoginType';
import { url, h5lLineComurl, wsUrl, preffix, preffixFile, preffixVideo, preffixImg, global, dimage } from './components/common/common'
// import { routerGo, getObjArr, arr, arr1 } from './router/import_router.js'
import { routerGo, getObjArr } from './router/import_router.js'
import 'normalize.css/normalize.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '@/styles/index1.scss'
import '../static/icon/iconfont.css'
import '../static/font/font.css'
import './components/index.js'
import axios from 'axios'
import 'vue-orgchart/dist/style.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// svg-icon
import '@/icons'
import './utils/rem.js'
import qs from 'qs'
import moment from 'moment'
import VueCropper from 'vue-cropper'
import VueClipboard from 'vue-clipboard2'
initLoginType();
Vue.use(ElementUI, { locale })
Vue.use(VueCropper)
Vue.use(VueClipboard)

const echarts = require('echarts');
Vue.prototype.$echarts = echarts
// import VeeValidate, {Validator} from 'vee-validate';
// // 添加表单验证
// Vue.use(VeeValidate, {
//   classes: true,
//   classNames: {
//     valid: 'is-valid',
//     invalid: 'is-invalid'
//   }
// });

// 路由跳转进度条
NProgress.inc(0.5) // 简单配置进度条
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false
})
// console.log(router)
var getRouter = null; // 用来获取后台拿到的路由
router.beforeEach((to, from, next) => {
  // console.log(to.meta.code,'0000000000000')
  NProgress.start()
  if (!Vue.prototype.$getRouter) { // 第一次请求
    if (!getObjArr('router') && to.path !== '/login') { // 无路由
      axios.get('/menu/getShowMenu').then(res => {
        if (res.data.success && res.data.data && res.data.data.length) {
          getRouter = res.data.data // 拿到路由,存储路由到localStorage
          Vue.prototype.$getRouter = getRouter;
          localStorage.setItem('router', JSON.stringify(getRouter))
          routerGo(to, next, getRouter) // 执行路由跳转方法
        } else { // 无权限
          next('/login')
        }
      })
    } else if (to.path === '/login') {
      next()
    } else { // 从localStorage拿到了路由
      getRouter = getObjArr('router') // 拿到路由
      Vue.prototype.$getRouter = getRouter;
      routerGo(to, next, getRouter)
    }
  } else {
    next()
  }

  // var isPlatformManager = localStorage.getItem('isPlatformManager');
  // if(!getRouter){
  //   console.log(999)
  //   if (!getObjArr('router') && to.path != '/login') {
  //     if (isPlatformManager=='1') {
  //       getRouter = arr
  //       window.localStorage.setItem('router',JSON.stringify(arr))
  //       routerGo(to, next,arr)
  //     }else if(isPlatformManager=='0'){
  //       getRouter = arr1
  //       window.localStorage.setItem('router',JSON.stringify(arr1))
  //       routerGo(to, next,arr1)
  //     }else{ //无权限
  //       next('/login')
  //     }
  //   }else if(to.path === '/login'){
  //     next()
  //   } else {//从localStorage拿到了路由
  //     console.log(1111)
  //     getRouter = getObjArr('router')//拿到路由
  //     routerGo(to, next,getRouter)
  //   }
  // }else{
  //   next();
  // }

  // getShowOption(to.meta.code)
})
// function getShowOption (code) {
//   if (!code) { return }
//   this.$axios.get('/menu/getShowOption', { params: { funcId: code } }).then(res => {
//     if (res.data.code === '0') {
//       window.localStorage.setItem('Auths', JSON.stringify(res.data.data));
//     } else {
//       window.localStorage.setItem('Auths', JSON.stringify([]));
//     }
//   })
// }
router.afterEach(() => {
  NProgress.done()
})

axios.defaults.baseURL = url;
axios.defaults.timeout = 40000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

Vue.prototype.$axios = axios;
//  设置请求拦截器和响应拦截器
axios.interceptors.request.use(
  config => {
    config.headers.common['Authorization'] = window.localStorage.getItem('token');
    config.headers.common['device_type'] = 'pc';
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// axios.interceptors.response.use(
//   response => {
//     if (response.data.code === '-1000') {
//       router.push({ path: '/login' })
//     }
//     if (response.data.code === '-1001') {
//       ElementUI.Message({
//         message: '暂无权限',
//         type: 'error',
//         center: true
//       })
//     }
//     return response
//   },
//   err => {
//     return Promise.reject(err)
//   }
// )

// import config from '../config'
// import vueLoaderConf from '../build/vue-loader.conf'

function deepClone (source) {
  const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for (let keys in source) { // 遍历目标
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') { // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else { // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}
// 这个方法是监测浏览器窗口发生变化的时候执行 切换账号时 其他窗口自动刷新为最新的当前帐号
window.addEventListener('visibilitychange', function () {
  console.log('窗口切换')
  if (document.hidden === false && global.token !== localStorage.getItem('token')) {
    // 只有当初始创建的username不等于localStorage里面的userId的时候去覆盖掉这个username的值并且需要先刷新浏览器窗口
    // 原生JS提供的方法
    window.location.reload()
    global.token = localStorage.getItem('token')
  } else {
    global.token = localStorage.getItem('token')
  }
})
Vue.config.productionTip = false
Vue.prototype.bus = new Vue()
Vue.prototype.$server = url;
Vue.prototype.$wsUrl = wsUrl;
Vue.prototype.$h5lineUrl = h5lLineComurl;
Vue.prototype.$qs = qs;
Vue.prototype.$preffix = preffix;
Vue.prototype.$preffixFile = preffixFile;
Vue.prototype.$preffixVideo = preffixVideo;
Vue.prototype.$preffixImg = preffixImg;
Vue.prototype.$dimage = dimage;
Vue.prototype.$deepClone = deepClone;
Vue.prototype.$orgId = 'ccc914581528a97bd03f10bde5b5bdea';
Vue.prototype.$moment = moment; // 日期格式化
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js